<template>
  <main id="main">
    <div class="hold-list">
      <div>
        <span>Avg. SOH</span>
        <b>{{ car_average.bat_soh }}%</b>
      </div>
      <div>
        <span>CO₂ Emissions</span>
        <b>{{ car_average.carbon }}(t)</b>
      </div>
      <div>
        <span>Carbon Credit Value</span>
        <b>{{ car_average.carbon_money }}</b>
      </div>
      <div>
        <span>Battery Residual Value</span>
        <b>{{ car_average.bat_price }}</b>
      </div>
      <div>
        <span>Avg. Battery Grade</span>
        <b>Grade {{ car_average.bat_grade }}</b>
      </div>
    </div>

    <section>
      <div class="car-avg-soh">
        <h3 class="title-style-1">Average SOH</h3>
        <div class="chartdata">
          <div class="databox">
            <p class="title">Legend</p>
            <div class="list">
              <ul>
                <li>SOH (Unit: %)</li>
                <li>
                  <img src="@/assets/images/icon/chart-bus-icon.png" alt="">
                  Total: {{car_info.length}} vehicles
                </li>
              </ul>
            </div>
          </div>
          <div class="container">
            <div id="anychart" class="chart" ref="anychart"></div>
          </div>
        </div>
      </div>

      <div class="car-chart">
        <h3 class="title-style-1">Vehicle Remaining Life Overview</h3>
        <div class="chartdata">
          <div class="databox">
            <p class="title">Legend</p>
            <div class="list">
              <ul>
                <li>Under 1 year</li>
                <li>1~3 years</li>
                <li>3~5 years</li>
                <li>Over 5 years</li>
              </ul>
            </div>
          </div>
          <div class="container">
            <div id="anychart2" class="chart" ref="anychart2"></div>
          </div>
        </div>
      </div>

      <div class="car-tbl">
        <div class="car-tbl-top">
          <select @change="change_option($event)" id="route_option" class="select-style-1">
            <option value="0">All Routes</option>
            <option v-for="data in route_list" :key="data.idx" :value="data.idx">{{data.route_nm}}</option>
          </select>
          <button type="button" @click="popup = true" v-on:click="get_chart_data(0,'Overall Analysis')">
            Overall Analysis
            <img src="@/assets/images/icon/search-white.png">
          </button>
        </div>
        <div class="tbl-section">
          <table>
            <thead>
              <tr>
                <td>NO.</td>
                <td>Route</td>
                <td>Vehicle No.</td>
                <td>Total Mileage (km)</td>
                <td>Total Emissions (kg)</td>
                <td>Battery SOH</td>
                <td>Remaining Life</td>
                <td>vs. Warranty</td>
              </tr>
            </thead>

            <tbody>
              <tr v-for="data in car_info" :key="data.idx" @click="popup = true" v-on:click="get_chart_data(data.idx,data.car_number)">
                <td>{{ data.no }}</td>
                <td>{{ data.route_nm }}</td>
                <td>{{ data.car_number }}</td>
                <td>{{ data.car_odo_meter }}</td>
                <td>{{ data.carbon }}</td>
                <!-- <td><progress style="color: red;" :value="data.bat_soh" max="100" class="progress"></progress> {{ data.bat_soh }}%</td> -->
                <td>
                  <div class="progress-value normal">{{ data.bat_soh }}%</div>
                  <!-- <div class="progress-value over">{{ data.bat_soh }}</div> -->
                  <!-- <div class="progress-value under">{{ data.bat_soh }}</div> -->
                  <div id="progress" class="progress">
                    <div
                      class="progress__avg"
                      :style="'left: ' + car_average.bat_soh + '%'"></div>
                    <div
                      class="progress__selected"
                      :style="'width: ' + data.bat_soh + '%'">
                    </div>
                  </div>
                </td>
                <td>{{ data.warranty_period }}</td>
                <td>{{ data.warranty_remain }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="popup" :class="'popup ' + (popup === true ? 'active' : '')">
        <div class="popup_window">
          <div class="popup_header">{{ title }}</div>
            <div class="popup_close">
              <button type="button" @click="popup = false"></button>
            </div>
            <div id="anychart3" class="chart" ref="anychart3"></div>
            <div id="anychart4" class="chart" ref="anychart4"></div>
          <div class="text">
            ※ This data is calculated based on KRX KAU201 standards.
          </div>
        </div>
      </div>    
    </section>
  </main>
</template>

<script>
import anychart from 'anychart'

export default {
  name: 'Home',

  data () {
    return {
      popup: false,
      route_option: 0,
      car_info: '',
      car_life: [0,0,0,0],
      car_average: {
        bat_soh: 0,
        carbon: 0,
        carbon_money: 0,
        bat_price: 0,
        bat_grade: 0
      },
      route_list: '',
      title: '',
    }
  },

  mounted () {
    this.home_get_car_info();
    this.home_get_car_average();
    this.get_route_list();
  },

  methods: {
    // 팝업데이터 가져오기
    get_chart_data: function(idx,title){
      var post_data = {idx: idx, route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/home_get_chart_data', post_data).then(res => {
        this.title = title;
        this.anychart3(res.data.month);
        this.anychart4(res.data.month);
      });
    },
    //

    // 옵션 선택시 데이터 새로 설정
    change_option: function(event){
      this.car_average.bat_soh = 0;
      this.car_average.carbon = 0;
      this.car_average.carbon_money = 0;
      this.car_average.bat_price = 0;
      this.car_average.bat_grade = 0;

      this.route_option = event.target.value;
      this.home_get_car_info(event);
      this.home_get_car_average(event);
      this.get_route_list();
    },

    // 차량 정보 가져오기
    home_get_car_info: function (event) {
      // 기본값 - 전체
      var route_option = "0";

      // 선택한 노선이 있는경우
      if(event){
        route_option = event.target.value;
      }
      //

      // 데이터 가져오기
      var post_data = {route_option: route_option, group_id: this.$store.getters.getGroupId};
      this.$axios.post('/api/home_get_car_info', post_data).then(res => {
        this.car_info = res.data.result[0];
        this.car_life = res.data.result[1];
        
        //차트 반영
        this.anychart2();
      });
    },

    // 차량 평균값 가져오기
    home_get_car_average: function (event) {
      // 기본값 - 전체
      var route_option = "0";

      // 선택한 노선이 있는경우
      if(event){
        route_option = event.target.value; 
      }
      //

      // 데이터 가져오기
      var post_data = {route_option: route_option, group_id: this.$store.getters.getGroupId};
      this.$axios.post('/api/home_get_car_average', post_data).then(res => {
        this.car_average = res.data.result[0];
        
        //차트 반영
        this.anychart1();
      });
      //
    },

    get_route_list: function () {
      var post_data = {group_id: this.$store.getters.getGroupId};
      this.$axios.post('/api/get_route_list', post_data).then(res => {
        this.route_list = res.data.rows;
      });
    },

    anychart1: function () {
      this.$refs.anychart.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create data set
        var data = anychart.data.set([
          ['SOH', this.car_average.bat_soh],
          ['Remaining', 100-this.car_average.bat_soh],
        ]);

        // create pie chart with passed data
        var chart = anychart.pie(data);
        chart.noData().label().enabled(true);
        chart.noData().label().text("No Data");
        
        // set chart radius
        chart
          .innerRadius('70%')
          // set value for the exploded slices
          .explode(25);

        // create standalone label and set settings
        var label = anychart.standalones.label();
        label
          .enabled(true)
          .text(this.car_average['bat_soh'])
          .width('100%')
          .height('100%')
          .adjustFontSize(true, true)
          .minFontSize(10)
          .maxFontSize(25)
          .fontColor('#60727b')
          .position('center')
          .anchor('center')
          .hAlign('center')
          .vAlign('middle');

        // set label to center content of chart
        chart.center().content(label);

        // create range color palette with color ranged
        var palette = anychart.palettes.rangeColors();
        palette.items(['#0f7b7d','#F2F2F2']);
        // set chart palette
        chart.palette(palette);

        // set hovered settings
        chart.hovered().fill('#6f3448');

        // set selected settings
        chart.selected().fill('#ff6e40');

        // set hovered outline settings
        chart
          .hovered()
          .outline()
          .fill(function () {
            return anychart.color.lighten('#6f3448', 0.55);
          });

        // set selected outline settings
        chart
          .selected()
          .outline()
          .offset(5)
          .fill(function () {
            return anychart.color.lighten('#ff6e40', 0.25);
          });

          //워터마커 제거
          anychart.licenseKey("4dream-8254134a-23a23715");
          var credits = chart.credits();
          credits.enabled(false);

          chart
          .tooltip()
          .positionMode('point')
          .position('center-top')
          .anchor('center-bottom')
          .offsetX(0)
          .offsetY(5)
          .titleFormat('SOH')
          .format('{%Value}{groupsSeparator: } %');
          
          // turn on chart animation
          chart.animation(true);
          
        // set container id for the chart
        chart.container('anychart');
        // initiate chart drawing
        chart.draw();
      });
    },

    anychart2: function () {
      this.$refs.anychart2.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create data set
        var data = anychart.data.set([
          [this.car_life[0], this.car_life[1], this.car_life[2], this.car_life[3]]
        ]);

        // create cartesian chart
        var chart = anychart.cartesian();
        chart.noData().label().enabled(true);
        chart.noData().label().text("No Data");
        
        // set chart title
        chart.title('');

        // create first series with mapped data and set it's name
        chart
          .column(
            data.mapAs({
              x: 0,
              value: 0
            })
          )
          .name('≤1yr');

        // create second series with mapped data and set it's name
        chart
          .column(
            data.mapAs({
              x: 0,
              value: 1
            })
          )
          .name('1~3yr');

        // create third series with mapped data and set it's name
        chart
          .column(
            data.mapAs({
              x: 0,
              value: 2
            })
          )
          .name('3~5yr');

        chart
        .column(
          data.mapAs({
            x: 0,
            value: 3
          })
        )
        .name('5yr+');

        // enable categorizedBySeries mode
        chart.categorizedBySeries(true);

        // enable chart legend
        //chart.legend(true);

        var palette = anychart.palettes.rangeColors();
        palette.items(['#e74f4d','#eb7327', '#eba923', '#76c6bb']);
        // set chart palette
        chart.palette(palette);

      //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);

        chart
        .tooltip()
        .positionMode('point')
        .position('center-top')
        .anchor('center-bottom')
        .offsetX(0)
        .offsetY(5)
        .titleFormat('{%SeriesName}')
        .format('{%Value}{groupsSeparator: } vehicles');
    
        // grid set
        chart.yGrid(true);
        
        // turn on chart animation
        chart.animation(true);
        
        // set container id for the chart
        chart.container('anychart2');
        // initiate chart drawing
        chart.draw();
      });
    },

    anychart3: function (msg) {
      this.$refs.anychart3.innerHTML = "";
      anychart.onDocumentReady(() => {
        var rows_array = [];
        for(var i=0; i<msg.length; i++){
          var row = [];
          row.push("M"+(i+1), msg[i][1], msg[i][2]);
          rows_array.push(row);
        }
        
          // create data set on our data
                var chartData = {
                  title: 'CO\u2082 Emission Reduction',
                  header: ['#', 'CNG', 'EV'],
                  rows: rows_array                    
                };
        
                // create column chart
                var chart = anychart.column();
            
                // set chart data
                chart.data(chartData);
        
                // turn on chart animation
                chart.animation(true);
            
                chart.yAxis().labels().format('{%Value}{groupsSeparator:\\,}');
        
                // set titles for Y-axis
                chart.yAxis().title('Unit: kg');
            
                chart
                  .labels()
                  .enabled(true)
                  .position('center-top')
                  .anchor('center-bottom')
                  .format('{%Value}{groupsSeparator:\\,}');
                chart.hovered().labels(false);
        
                // grid set
                chart.yGrid(true);
                
                // turn on legend and tune it
                chart.legend().enabled(true).align('right').fontSize(13).padding([0, 0, 20, 0]);
                
                // interactivity settings and tooltip position
                chart.interactivity().hoverMode('single');
        
                chart
                  .tooltip()
                  .positionMode('point')
                  .position('center-top')
                  .anchor('center-bottom')
                  .offsetX(0)
                  .offsetY(5)
                  .titleFormat('{%X}')
                  .format('{%SeriesName} : {%Value}{groupsSeparator:\\,} kg');
    
              //워터마커 제거
            anychart.licenseKey("4dream-8254134a-23a23715");
                var credits = chart.credits();
              credits.enabled(false);

              var palette = anychart.palettes.rangeColors();
                palette.items(['#41a382','#4e4d4d']);
                // set chart palette
                chart.palette(palette);
              
                // set container id for the chart
                chart.container('anychart3');
        
                // initiate chart drawing
                chart.draw();
      });
    },

    anychart4: function (msg) {
      this.$refs.anychart4.innerHTML = "";
      anychart.onDocumentReady(() => {
        var rows_array = [];
        for(var i=0; i<msg.length; i++){
          var row = [];
          row.push("M"+(i+1), msg[i][3]);
          rows_array.push(row);
        }
        
              // create data set on our data
              var chartData = {
                title: 'Carbon Credit Trading Profit',
                header: ['#', 'EV'],
                rows: rows_array
              };
      
              // create column chart
              var chart = anychart.column();
      
              // set chart data
              chart.data(chartData);
      
              // turn on chart animation
              chart.animation(true);
      
              chart.yAxis().labels().format('{%Value}{groupsSeparator:\\,}');
          
              // set titles for Y-axis
              chart.yAxis().title('Unit: KRW (×1000)');
      
              chart
                .labels()
                .enabled(true)
                .position('center-top')
                .anchor('center-bottom')
                .format('{%Value}{groupsSeparator:\\,}');
              chart.hovered().labels(false);
      
              // grid set
              chart.yGrid(true);
              
              // turn on legend and tune it
              chart.legend().enabled(true).align('right').fontSize(13).padding([0, 0, 20, 0]);
              
              // interactivity settings and tooltip position
              chart.interactivity().hoverMode('single');
      
              chart
                .tooltip()
                .positionMode('point')
                .position('center-top')
                .anchor('center-bottom')
                .offsetX(0)
                .offsetY(5)
                .titleFormat('{%X}')
                .format('{%SeriesName} : {%Value}{groupsSeparator:\\,} KRW(×1000)');

              //워터마커 제거
          anychart.licenseKey("4dream-8254134a-23a23715");
              var credits = chart.credits();
            credits.enabled(false);

            // set chart palette
              var palette = anychart.palettes.rangeColors();
                palette.items(['#188daa']);
                chart.palette(palette);
            
              // set container id for the chart
              chart.container('anychart4');
      
              // initiate chart drawing
              chart.draw();
      });
    },
  }
}
</script>

<style lang="scss" scoped>
#main {
  grid-row: 2/3;
  grid-column: 2/3;
  padding: 25px;
  overflow-y: auto;
  @include mobile {
    padding: 10px;
  }


  section {
    display: grid;
    grid-template-columns: 7fr 9fr;
    grid-template-rows: 1fr 1fr;
    gap: 25px;
    width: 100%;
    height: 800px;
    @include mobile {
      display: flex;
      flex-direction: column;
      height: auto;
      gap: 10px;
    }
  }

  section > div {
    border: 1px solid #979797;
    border-radius: 6px;
    background: #fff;
    padding: 25px;
    @include mobile {
      padding: 15px;
      width: 100%;
      border-radius: 4px;
    }

    .chartdata {
      $legendWidth: 300px;

      width: 100%;
      height: calc(100% - 57px);
      display: flex;
      justify-content: space-between;

      .databox {
        max-width: $legendWidth;
        min-width: 210px;
        width: 40%;
        height: 100%;
        border: 1px solid #5c5c5c;
        border-radius: 6px;
        overflow: hidden;
        @include mobile {
          min-width: 180px;
        }

        .title {
          line-height: 40px;
          padding-left: 24px;
          font-size: 18px;
          color: #022121;
          background: #eef2f5;
          border-radius: 6px 6px 0 0;
          font-weight: 600;
          @include mobile {
            padding-left: 15px;
            font-size: 16px;
          }
        }

        .list {
          padding: 24px;
          @include mobile {
            padding: 15px;
          }

          ul li {
            font-size: 18px;
            padding-left: 32px;
            line-height: 1;
            @include mobile {
              padding-left: 24px;
              font-size: 14px;
            }
          }
        }
      }

      .container {
        width: 60%;
        .chart {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .car-avg-soh {
    width: auto;
    min-width: 500px;
    height: auto;
    padding-right: 0;
    @include mobile {
      min-width: 100%;
      padding-left: 0;
      padding-right: 15px;
    }
    h3 {
      @include mobile {
        margin-left: 15px;
      }
    }
    .chartdata {
      @include mobile {
        flex-direction: row-reverse;
        align-items: center;
      }
    }
    li {
      position: relative;
      margin-bottom: 28px;
      &:last-child {
        margin-bottom: 0;
      }

      &:first-child::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 15px;
        height: 15px;
        border-radius: 2px;
        background: #077f80;
      }

      img {
        position: absolute;
        top: 50%;
        left: -6px;
        transform: translateY(-50%);
        @include mobile {
          width: 20px;
          left: -2px;
        }
      }
    }
  }

  .car-chart {
    width: auto;
    min-width: 500px;
    height: auto;
    padding-right: 0;
    @include mobile {
      min-width: 100%;
      padding: 15px;
    }
    .chartdata {
      @include mobile {
        flex-direction: column-reverse;
      }
      .databox {
        @include mobile {
          width: 100%;
          max-width: 100%;
        }
      }
      .container {
        max-width: 100%;
        width: 100%;
      }
    }
    li {
      position: relative;
      margin-bottom: 35px;
      &:last-child {
        margin-bottom: 0;
      }
      @include mobile {
        margin-bottom: 20px;
      }

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 15px;
        height: 15px;
        border-radius: 2px;
      }

      &:nth-child(1)::before {
        background: #e74f4d;
      }

      &:nth-child(2)::before {
        background: #eb7327;
      }

      &:nth-child(3)::before {
        background: #eba923;
      }

      &:nth-child(4)::before {
        background: #76c6bb;
      }
    }
  }

  .car-tbl {
    grid-row: 1/3;
    grid-column: 2;
    @include mobile {
      height: 400px;
    }

    .car-tbl-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;
      @include mobile {
        margin-bottom: 15px;
      }

      button {
        width: 167px;
        height: 40px;
        background: #077f80;
        border-radius: 2px;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        margin-right: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        @include mobile {
          margin-right: 0;
          width: 150px;
          height: 36px;
          font-size: 16px;
        }

        img {
          margin-left: 6px;
        }
      }
    }

    .tbl-section {
      overflow: auto;
      position: relative;
      width: 100%;
      margin-top: 20px;
      overflow-y: scroll;
      height: calc(100% - 70px);
      border-top: 5px solid #9e9e9e;
      table {
        width: 100%;
        min-width: 830px;
        border-collapse: collapse;
        thead {
          position: sticky;
          top: 0;
          left: 0;
          background: #fff;
          tr {
            height: 40px;
            cursor: default;
            font-size: 18px;
            font-weight: 600;
            color: #077f80;
          }
        }
        tr {
          height: 45px;
          cursor: pointer;
          border-bottom: 1px solid #9e9e9e;
          &:not(:first-child):hover {
            background: #f3f9f7;
          }
          td {
            text-align: center;
            font-size: 15px;
            padding: 9px 0;
            @include mobile {
              padding: 5px 0;
            }
            .progress-value {
              font-size: 15px;
              line-height: 1;
              margin-bottom: 6px;
              &.normal { color: #565656; }
              &.over { color: #00a588; }
              &.under { color: #f10000; }
            }
            .progress {
              width: 75%;
              height: 15px;
              border: 1px solid #5d5d5d;
              position: relative;
              margin: 0 auto;
              .progress__avg {
                position: absolute;
                top: 0;
                left: 50%;
                background: #ed7c89;
                width: 3px;
                height: 100%;
                z-index: 9;
              }
              .progress__selected {
                width: 0%;
                height: 100%;
                background: #3f5366;
                position: absolute;
                top: 0;
                left: 0;
                &::after {
                  content: '';
                  display: block;
                  width: 8px;
                  height: 5px;
                  background: #3f5366;
                  position: absolute;
                  top: -5px;
                  right: 0;
                  clip-path: polygon(0 0, 100% 0, 50% 100%);
                  transform: translateX(4px);
                }
              }
            }
          }
        }
      }
    }
  }

  .popup {
    display:none;
    position: fixed;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background-color:#48484899;
    z-index: 200;
    overflow-y: hidden;
    @include mobile {
      top: 49px;
      height: calc(100% - 50px);
      border-radius: 0;
      background: #f3f9f7 url('~@/assets/images/mob-popup-bg.png') no-repeat bottom center;
    }
    &.active {display: block;}
    .popup_window {
      width: 1000px;
      max-width: calc(100% - 40px);
      z-index: 201;
      background-color: white;
      border-radius: 5px;
      padding: 20px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      @include mobile {
        width: calc(100% - 20px);
        border: 1px solid #979797;
        top: 15px;
        transform: translate(-50%, 0);
        padding: 15px 0;
      }
      .chart {
        height: 350px;
        @include mobile {
          height: 250px;
        }
      }
    }
    .popup_header {
      background: #077f80;
      color: #fff;
      font-size: 35px;
      text-align: center;
      font-weight: 700;
      padding: 8px 24px;
      border-radius: 5px;
      margin-bottom: 35px;
      display: inline-block;
      @include mobile {
        font-size: 24px;
        margin-bottom: 10px;
        padding: 5px 15px;
      }
      .t1 {
        width: 350px;
        height: 34px;
        vertical-align: top;
        padding-left: 5px;
      }
      .b1 {
        margin: 0px;
        height: 34px;
        padding: 1px 14px;
      }
    }
    .popup_body {
      padding: 15px 10px;
      margin-bottom: 25px;
      height: 250px;
      border: 2px solid #ccc;
      border-radius: 5px 5px 5px 5px;
      margin-top: 5px;
      overflow-y: auto;
      position: relative;
    }
    .popup_close {
      text-align: right;
      position: absolute;
      top: 15px;
      right: 10px;
      z-index: 9;
      @include mobile {
        top: 20px;
      }
      button {
        border: none;
        background: transparent;
        width: 28px;
        height: 28px;
        background: url('~@/assets/images/icon/close.png') no-repeat center;
        cursor: pointer;
        @include mobile {
          width: 30px;
          height: 30px;
          background: url('~@/assets/images/icon/mob-close.png') no-repeat center;
          background-size: 100% 100%;
        }
      }
    }
    .text {
      text-align: left;
      font-size: 18px;
      color: #080000;
      padding-left: 20px;
      @include mobile {
        padding: 0 15px;
        font-size: 14px;
      }
    }
  }
}
</style>